<template>
    <div>
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <app-breadcrumb :page-title="$t('product_type')" :directory="$t('list')" :icon="'grid'" />
                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                        <button 
                            @click=" addProductType = true, list = false"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_product_type') }}
                        </button>

                    </div>
                </div>
            </div>
            <app-table :id="tableId" :options="options" @action="getListAction" :selected-url="selectedUrl" />
        </div>
 
        <app-delete-modal 
            v-if="deleteConfirmationModalActive" 
            :preloader="deleteLoader" 
            modal-id="demo-delete"
            @confirmed="confirmed" 
            @cancelled="cancelled" />

        <EditDetail
            v-if="editDetail"
            :id="this.rowData.id"
            @close="editDetail = false"
            @save="handleUpdateDetail" />    

        <AddProductType  
            v-if="addProductType"
            @close="addProductType = false"
            @save="handleSaveProductType" />    

    </div>
</template>

<script>
import configTable from "./mixins/configTable.js";
import * as actions from "../../../Config/ApiUrl.js";
import { FormMixin } from '../../../../core/mixins/form/FormMixin.js';
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import EditDetail from "./EditDetail.vue";
import { tableConditions } from './mixins/tableConditions.js';
import {  deleteDetail, updateDetail, saveProductType, deleteDetailProductType } from "./api/api.js";
import AddProductType from './AddProductType.vue';

export default {
    extends: CoreLibrary,
    mixins: [tableConditions, FormMixin],
    components :{
         EditDetail, AddProductType
    },  
    data() {
        return {
            tableId: 'advance-table',
            options: configTable,
            addCondition : false,
            addDetail : false,
            editDetail : false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            addProductType : false,
            rowData: {},
        }
    },
    created() {
        this.options.columns = this.tableColumns; // Asignar las columnas de la tabla
    },
    methods : {
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title === 'Delete') {
                this.openDeleteModal();
            }
            if (actionObj.title === 'Edit') {
                this.openEditModal();
            }
        },  


        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        cancelled() {
            this.deleteConfirmationModalActive = false;
            location.reload();
        },

        async confirmed() {
            const id = this.rowData.id;
            const res = await deleteDetailProductType(id);
            if (res.deleted) {
                $("#demo-delete").modal('hide');
                this.$toastr.s(res.message);
                this.cancelled();
                return;
            }
            this.$toastr.e(res.message);
        },

        openEditModal() {
            this.editDetail = true;
        },

        async handleSaveProductType(data){
            const res = await saveProductType(data);
            if (res.created) {
                this.$toastr.s(res.message);
                this.addProductType = false;
                this.$hub.$emit('reload-' + this.tableId);
                return;
            }
            this.$toastr.e(res.message);
        },

        async handleUpdateDetail(data){  
            const id = data.id_condition;
            const res = await updateDetail(id, data);
            if (res.updated) {
                this.$toastr.s(res.message);
                this.editDetail = false;
                this.$hub.$emit('reload-' + this.tableId);
                return;
            }
            this.$toastr.e(res.message);
        }
    },
}
    
</script>

